import React, {
  useRef,
  useState,
  useEffect
} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  useDispatch,
  useSelector
} from 'react-redux';
import {
  Avatar,
  Badge,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  SvgIcon,
  Tooltip,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  Bell as BellIcon,
  Package as PackageIcon,
  MessageCircle as MessageIcon,
  Truck as TruckIcon
} from 'react-feather';
import axios from 'src/utils/axios';
import { getNotifications } from 'src/actions/notificationsActions';
import { useTranslation } from 'react-i18next'

const iconsMap = {
  order_placed: PackageIcon,
  new_message: MessageIcon,
  item_shipped: TruckIcon,
  new_ticket: MessageIcon,
  edit_ticket: MessageIcon
};

const useStyles = makeStyles((theme) => ({
  popover: {
    width: 320
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  }
}));

function Notifications() {
  const classes = useStyles();
  const user = useSelector((state) => state.account.user);
  const notifications = useSelector((state) => state.notifications.notifications);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();
  //debugger;
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const hadleMarkAsReaded = () => {
    //debugger;
    dispatch(() => {
      axios.post('/api/Notification/Readed', notifications)
          .catch((error) => {
              
          }).then((response) => {
              if (response) {
                dispatch(getNotifications(user.user.id));
              }
          });
    });
  };

  useEffect(() => {
    dispatch(getNotifications(user.user.id));
  }, [dispatch,user.user.id]);

  if(notifications.length === 0) return null;

  return (
    <>
      <Tooltip title={t('dashboardLayout.topBar.notificationsTooltip')}>
        <IconButton
          color="inherit"
          ref={ref}
          onClick={handleOpen}
        >
          {notifications.length>0?
          <Badge badgeContent={notifications.length} color="error">
            <SvgIcon>
              <BellIcon />
            </SvgIcon>
          </Badge>
          :
          <SvgIcon>
            <BellIcon />
          </SvgIcon>
          }

          
        </IconButton>
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        classes={{ paper: classes.popover }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
      >
        <Box p={2}>
          <Typography
            variant="h5"
            color="textPrimary"
          >
            {t('dashboardLayout.topBar.notificationsTitle')}
          </Typography>
        </Box>
        {notifications.length === 0 ? (
          <Box p={2}>
            <Typography
              variant="h6"
              color="textPrimary"
            >
              {t('dashboardLayout.topBar.noNotifications')}
            </Typography>
          </Box>
        ) : (
          <>
            <List
              className={classes.list}
              disablePadding
            >
              {notifications.map((notification) => {
                const Icon = iconsMap[notification.notificationType];

                return (
                  <ListItem
                    className={classes.listItem}
                    component={RouterLink}
                    divider
                    key={notification.id}
                    to={"/app/tickets/" + notification.reference + "/edit"}
                  >
                    <ListItemAvatar>
                      <Avatar
                        className={classes.icon}
                      >
                        <SvgIcon fontSize="small">
                          <Icon />
                        </SvgIcon>
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={notification.title}
                      primaryTypographyProps={{ variant: 'subtitle2', color: 'textPrimary' }}
                      secondary={notification.description}                      
                    />
                  </ListItem>
                );
              })}
            </List>
            <Box
              p={1}
              display="flex"
              justifyContent="center"
            >
              <Button
                component={RouterLink}
                size="small"
                to="#"
                onClick={hadleMarkAsReaded}
              >
                {t('dashboardLayout.topBar.notificationAsRead')}
              </Button>
            </Box>
          </>
        )}
      </Popover>
    </>
  );
}

export default Notifications;
